package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.core.active_match.ActiveMatchController
import org.koin.dsl.module

val activeMatchModule = module {
    single { ActiveMatchController(storage = get()) }
}
